import React from 'react';
import PropTypes from 'prop-types';

import {connect} from 'react-redux';
import {browserHistory} from 'react-router';

import {removeProductFromCart} from '../../ducks/cart';
import {closeModal} from '../../ducks/ui';

import CartModal from '../../components/modals/CartModal';

@connect(({cart}) => ({cart}))
export default class CartModalContainer extends React.PureComponent {
  static modalName = 'cart';

  render() {
    const {dispatch, cart, ...rest} = this.props;

    return (
      <CartModal
        items={cart ? cart.items : []}
        onRemove={itemId => dispatch(removeProductFromCart(itemId))}
        onCheckout={() => {
          dispatch(closeModal());
          browserHistory.push('/checkout');
        }}
        {...rest}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./containers/cartModalContainer/CartModalContainer.js